import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { onMounted, reactive, toRefs, watch } from "vue";
import apis from "@/api";
import common from "../composables/common";
export default {
  name: "SetDesigner",
  props: {
    depart: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    designer: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const {
      getDesignCompanies,
      commonData
    } = common();
    const data = reactive({
      loading: false
    });
    const close = () => {
      context.emit('update:visible', false);
    };
    const hanldeSubmit = () => {
      data.loading = true;
      apis.setDesigner(props.designer).then(res => {
        if (res.success) {
          ElMessage({
            type: 'success',
            message: '运营位指定设计方成功'
          });
          context.emit('success');
          close();
        } else {
          ElMessage.error(res.msg);
        }
        data.loading = false;
      });
    };
    const handleChange = val => {
      const designer = props.designer;
      commonData.designers.forEach(d => {
        if (d.userId == val) {
          designer.designAccount = val;
          designer.designName = d.empName;
        }
      });
      context.emit('update:designer', designer);
    };
    watch(() => props.depart, val => {
      getDesignCompanies({
        depart: val
      });
    });
    onMounted(() => {
      getDesignCompanies();
    });
    return {
      ...toRefs(commonData),
      ...toRefs(data),
      close,
      hanldeSubmit,
      handleChange
    };
  }
};